import { render } from "./ParkingPassWaitingRegView.vue?vue&type=template&id=40b38c3e&scoped=true"
import script from "./ParkingPassWaitingRegView.vue?vue&type=script&lang=js"
export * from "./ParkingPassWaitingRegView.vue?vue&type=script&lang=js"

import "./ParkingPassWaitingRegView.vue?vue&type=style&index=0&id=40b38c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b38c3e"]])

export default __exports__